

export const helpers = {
  numberWithCommas: function(x:number) {
    x=(Math.round(x*100))/100;return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
}

